import { writable } from 'svelte/store'
import type { TCredenzaPublicClient } from "../utils/types";

export const clientPublicStore = writable<TCredenzaPublicClient>()
